import { ChartMultipleRegular, CheckRegular, PeopleTeamRegular, ArrowClockwiseFilled, SearchInfoRegular } from "@fluentui/react-icons";
import { RiTeamFill } from "react-icons/ri";
import { FaUserCog } from "react-icons/fa";
import { IoRibbonSharp } from "react-icons/io5";
import { TbBulbFilled } from "react-icons/tb";
// import {SapIcon} from '../../assets/SapIcon';
import SAPIcon from "../../assets/SAP.svg";
import ROR from "../../assets/ROR.svg";
// import {RoRIcon} from '../../assets/RorIcon';
import VayuIcon from "../../assets/vayu_icon.svg";
import HVDCAcademy from '../../assets/HVDCAcademy.svg'
import ZaragozaIcon from '../../assets/ZaragozaIcon.svg';
import ProjectNavigator from '../../assets/project_navigator.svg'
import Taiju from '../../assets/taiju.svg'
import SapCoeIcon from '../../assets/sapcoe.svg'
import grcmTile from '#/assets/grcm_tile.svg';

export const enum messageStatus {
  NotRunning = "Not Running",
  Processing = "Processing",
  Done = "Done"
}

export const enum agentMode {
  PROJECT_INSIGHTS,
  PORTFOLIO_INSIGHTS,
  NEW_CCRPS_FROM_LAST_WEEK,
  PROGRESS_BREAKDOWN,
  UNDEFINED
}


const IconWrapper: React.FC<{ icon: React.ReactNode; sizeEm?: number; alt?: string }> = ({
  icon,
  sizeEm = 1.5,
  alt = "Icon",
}) => (
  <img src={icon as string} alt={alt} style={{ width: `${sizeEm}em` }} />
);  

export const iconMap = {
  chart: <ChartMultipleRegular />,
  check: <CheckRegular />,
  people: <PeopleTeamRegular />,
  clock: <ArrowClockwiseFilled />,
  search: <SearchInfoRegular />,
  WrenchRegular: <FaUserCog />,
  ccrp: <RiTeamFill />,
  pmCert: <IoRibbonSharp />,
  sap: <IconWrapper icon={SAPIcon} alt="SAP Icon" sizeEm={1}/>,
  ror: <IconWrapper icon={ROR} alt="RoR Icon" sizeEm={2}/>,
  vayu: <IconWrapper icon={VayuIcon} alt="Vayu Icon" />,
  HVDCAcademy: <IconWrapper icon={HVDCAcademy} alt="HVDC Academy Icon" sizeEm={1} />,
  Zaragoza: <IconWrapper icon={ZaragozaIcon} alt="Zaragoza Icon" />,
  ProjectNavigator:<IconWrapper icon={ProjectNavigator} alt="Project Navigator Icon" sizeEm={1} />,
  hseIncident: <TbBulbFilled />,
  taiju: <IconWrapper icon={Taiju} alt="Taiju Icon" sizeEm={1} />,
  digitalCoreCoe: <IconWrapper icon={SapCoeIcon} alt="Digital Core Icon" />,
  grcmTile: <IconWrapper icon={grcmTile} alt="GRCM Tile Icon" sizeEm={1}/>,
};

export const initialTilesData = [
  { title: "SCM", content: "", icon:iconMap.vayu, shouldBeDisabled : false, sortOrder: 2 },
  { title: "Finance", content: "incl. FARM", icon:iconMap.vayu, shouldBeDisabled : false, sortOrder: 3 },
  { title: "Project Data Insights", content: "Analyze project data [GI]", icon: iconMap.chart, shouldBeDisabled: true, sortOrder: 4 },
  { title: "PGGA Insights", content: "PGGA Insights", icon: iconMap.search, shouldBeDisabled: true, sortOrder: 6 },
  { title: "TrafoChat", content: "TrafoChat", icon: iconMap.WrenchRegular, shouldBeDisabled: true, sortOrder: 5 },
  { title: "CCRP", content: "CCRP", icon: iconMap.search, shouldBeDisabled: true, sortOrder: 1 },
  { title: "Switch Insights", content: "HV Products and Services", icon:iconMap.WrenchRegular, shouldBeDisabled : true, sortOrder: 7 },
  { title: "Switch Insights", content: "PGHV Databases", icon:iconMap.WrenchRegular, shouldBeDisabled : true, sortOrder: 7 },
  { title: "Digital Core CoE", content: "SAP Processes and Information", icon:iconMap.sap, shouldBeDisabled : true, sortOrder: 8 },
  { title: "RoR Platform", content: "VEE-G5 Technology", icon:iconMap.ror, shouldBeDisabled : true, sortOrder: 9 },  
  { title: "Reasoning", content: "Chat GPT-5", icon: iconMap.search, shouldBeDisabled: true, sortOrder: 11 },
  { title: "Nuclear Legal", content: "Your Virtual Nuclear Counsel", icon: iconMap.search, shouldBeDisabled: true, sortOrder: 8 },
  { title: "HV Project", content: "HV Project - Order Tracking Tool", icon: iconMap.chart, shouldBeDisabled: true, sortOrder: 10 },
  { title: "PM Certification", content: "Analyze PM Certification", icon: iconMap.pmCert, shouldBeDisabled: true, sortOrder: 5 },
  { title: "HVDC Academy", content: "", icon:iconMap.HVDCAcademy, shouldBeDisabled : true, sortOrder: 12 },
  { title: "Zaragoza Engineering", content: "Engineering Process Assistant", icon:iconMap.Zaragoza, shouldBeDisabled : true, sortOrder: 13 },
  { title: "Project Navigator", content: "", icon:iconMap.ProjectNavigator, shouldBeDisabled : true, sortOrder: 13 },
  { title: "HSE Incident", content: "High Potential Incident Reports", icon:iconMap.hseIncident, shouldBeDisabled : true, sortOrder: 14 },
  { title: "Taiju", content: "", icon:iconMap.taiju, shouldBeDisabled : true, sortOrder: 15 },
  { title: "Digital Core", content: "Project Management", icon:iconMap.digitalCoreCoe, shouldBeDisabled : true, sortOrder: 16 },
  { title: "GRC Platforms", content: "GRCM - Group Risk and Compliance Management", icon:iconMap.grcmTile, shouldBeDisabled : true, sortOrder: 16 },
];

export const promptMappings: Record<string, string> = {
  "HV Project - Order Tracking Tool": "hv_project_tracker",
  "PGGA Insights": "pgga",
  "PGTR Engineering": "pgtr_engineering",
  "TrafoChat": "pgtr_engineering",
  "Analyze project data [GI]": "structured",
  "CCRP": "ccrp",
  "HV Products and Services": "pghv",
  "PGHV Databases": "pghv_structure",
  "SAP Processes and Information": "digital_core_coe",
  "VEE-G5 Technology": "ror",
  "Chat GPT-5": "gpt5_gk",
  "SCM": "vayu",
  "Finance": "vayu",
  "incl. FARM": "vayu",
  "Your Virtual Nuclear Counsel": "lc_nuclear",
  "Analyze PM Certification": "pmcert",
  "HVDC Academy":"hvdc_academy",
  "Engineering Process Assistant":"zaragoza",
  "High Potential Incident Reports":"hse_incident",
  "Project Management": "sap_coe",
  "GRCM - Group Risk and Compliance Management":"grcm"
};

export const constants = {
    function:{
        portfolioInsights: "PORTFOLIO_INSIGHTS",
        projectInsights: "PROJECT_INSIGHTS",
        ccrpLastWeek: "NEW_CCRPS_FROM_LAST_WEEK",
        issueOverview: "ISSUE_OVERVIEW",
        progressBreakdown: "PROGRESS_BREAKDOWN",
        ccrpAiAnalyzer: "AI_ANALYZER",
        coeKnowledgeHub: "SAP_KNOWLEDGE_HUB",
        sapProjectInsights: "SAP_PROJECT_INSIGHTS",
        changeDataSource: "CHANGE_DATA_SOURCE"
    },
    agent:{
        pgga: 'pgga',
        pggall: 'pggall',
        trafochat: 'trafochat',
        pggaLessonsLearned: 'pgga_lessons_learned',
        pgtrEngineering: 'pgtr_engineering',
        structured: 'structured',
        unstructured: 'unstructured',
        ccrp: 'ccrp',
        pghv: 'pghv',
        pghvDatabases: 'pghv_structure',
        sapCoe: 'digital_core_coe',
        ror: 'ror',
        lcNuclear: 'lc_nuclear',
        gpt5_gk: 'gpt5_gk',
        hvproject: 'hv_project_tracker',
        scm:'scm',
        finance:'finance',
        vayu: 'vayu',
        pmcert: 'pmcert',
        zaragoza: 'zaragoza',
        hseincident: 'hse_incident',
        digitalCoreCoe: 'sap_coe',
        grcm: 'grcm'
    },
    mappedAgent:{
        pgga: 'PGGA Insights',
        pgtrEngineering: 'TrafoChat',
        structured: 'Analyze project data [GI]',
        unstructured: 'General',
        ccrp: 'CCRP',
        pghv: 'Documents & Trainings',
        pghvDatabases: 'HV Databases',
        sapCoe: 'SAP Processes and Information',
        ror: 'VEE-G5 Technology',
        lcNuclear: 'Your Virtual Nuclear Counsel',
        gpt5_gk: 'Chat GPT-5',
        scm:'SCM',
        finance:'Finance',
        pmcert: 'PM Certification',
        zaragoza: 'Engineering Process Assistant',
        hseincident: 'High Potential Incident Reports',
        digitalCoreCoe: 'Project Management',
        grcm: 'GRCM - Group Risk and Compliance Management'
    }
}